<template>
  <vs-row vs-type="flex" vs-w="12" class="py-4">
    <new-transfer ref="newTransfer" @reload="resetCheckStockTransfer" />
    <vs-row vs-type="flex" vs-w="12" vs-justify="center">
        <span class="weight-500">
          Geçtiğimiz ayın stok sransferi yapılmamış ! Paneli kullanmaya devam edebilmek için lütfen transferinizi tamamlayınız.
        </span>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="mt-2" vs-justify="center">
      <vs-button @click="openNewTransfer">
        Stok Transferini Gerçekleştir
      </vs-button>
    </vs-row>
  </vs-row>
</template>

<script>
import NewTransfer from "@/views/pages/MonthlyStockTransfer/NewTransfer"
export default {
  name: "StockTransferBlocker",
  data()
  {
    return {
      month: 'MONTH',
      canRedirect: false
    }
  },
  components: {
    NewTransfer
  },
  methods:{
    openNewTransfer() {
      this.$refs.newTransfer.isActive = true
    },
    resetCheckStockTransfer() {
      this.$store.dispatch("setNeedStockTransfer").then(() => {
        if(!this.$needStockTransfer()) {
          this.$router.push(this.$route.query.to === '/pages/login' ? '/' : this.$route.query.to)
        }
      });
    }
  }
}
</script>

<style>
#stockTransferBlocker .vs-popup--close {
  display: none;
}
</style>
